const gDriveSwitchPage = $('body').hasClass('page--gdriveswitch');

let cacoo = require('../components/cacoo').cacoo;

if (gDriveSwitchPage) {
  class GDriveSwitch {
    constructor() {
      this.form = $('#switchDriveForm', $('body'));
      this.mail = $('input[name="email"]', this.form).val();
      this.next = $('input[name="next"]', this.form).val();
      this.submitButton = $('button[type="submit"]', this.form);
      this.attachEvent();
    }

    attachEvent() {
      this.submitButton.on('click', () => {
        this.submit();
      });
    }

    submit() {
      const data = {
        email: this.mail,
        next: this.next,
      };
      cacoo.ajax({
        url: this.form.attr('action'),
        method: 'POST',
        data: data,
        beforeSend: () => {
          this.startButtonSpinner();
        },
        success: (switchResponse) => {
          this.stopButtonSpinner();
          window.location.href = switchResponse['completionUrl'];
        },
        error: (err) => {
          console.error(err)
          return false;
        },
        timeout: 30000
      })
    }

    startButtonSpinner() {
      this.submitButton.addClass('disable');
    }

    stopButtonSpinner() {
      this.submitButton.removeClass('disable');
    }
  }

  new GDriveSwitch();
}
